import api from "api";
import { supportApiBase } from "api/constants";
import { useQuery } from "react-query";
import { useId } from "utils/hooks";
import { queryKeys } from "utils/misc";
import { UserListItem } from "routes/users/queries/useListUsers";

const useGetUser = () => {
  const id = useId();

  return useQuery(
    queryKeys.userSearch({ category: "id" as any, search: String(id) }),
    async (): Promise<UserListItem | undefined> => {
      const response = await api.call(`/users?id=${id}`, { root: supportApiBase });
      const body = await response.json();
      return body?.items?.[0];
    },
    { enabled: !!id }
  );
};

export default useGetUser;
